module.exports = __webpack_public_path__ + "img/voice-foundry.e400f19c.png";